import React from 'react';

import { Markdown } from '../../General/Markdown';

interface Props {
    omschrijving?: string | null;
    aanvullendeInformatie?: string | null;
}

const Description: React.FC<Props> = ({ omschrijving, aanvullendeInformatie }: Props) => {
    if (!omschrijving?.length && !aanvullendeInformatie?.length) {
        return null;
    }

    return (
        <>
            {omschrijving?.length && !aanvullendeInformatie?.length && <>{omschrijving}</>}
            {!omschrijving?.length && aanvullendeInformatie?.length && (
                <div className="description-wrapper">
                    <div className="description">
                        <Markdown text={aanvullendeInformatie} />
                    </div>
                </div>
            )}
            {omschrijving?.length && aanvullendeInformatie?.length && (
                <div className="description-wrapper">
                    <div className="description">
                        <Markdown text={omschrijving} />
                        <hr />
                        <Markdown text={aanvullendeInformatie} />
                    </div>
                </div>
            )}
        </>
    );
};

export default Description;
